export default __webpack_public_path__ + "static/media/ql_10.67c6c073.png";